import { createUseStyles } from "react-jss";

export const useStyles = () => {
  return createUseStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      border: "1px solid #F1F2F4",
      borderRadius: "8px",
      width: "434px",
      height: "280px",
      boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.04)',
      background: "white",
    },
    title: {
      color: "#7B7B7B",
      fontWeight: 600,
      fontSize: "24px",
      marginTop: "16px",
    },
    chartWrapper:{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }
  })();
};
